import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-search-select/dist/VueSearchSelect.css'

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'
import JsonExcel from "vue-json-excel";
import VueBootstrapToasts from "vue-bootstrap-toasts";
Vue.use(VueBootstrapToasts);

// axios
import axios from 'axios';

if (process.env.NODE_ENV === 'production') {
    // axios.defaults.baseURL = 'https://movetechapp.poscreamug.com/api/'
    axios.defaults.baseURL = 'https://testback.poscreamug.com/api/'
}else{
    axios.defaults.baseURL = 'http://127.0.0.1:8000/api/'
    // axios.defaults.baseURL = 'https://newapp.poscreamug.com/api/'
    // axios.defaults.baseURL = 'https://demoback.poscreamug.com/api/'
    // axios.defaults.baseURL = 'https://katacornsapp.poscreamug.com/api/'

}

const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTId,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPId,
    measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
    initFirebaseBackend(firebaseConfig);
} else {
    configureFakeBackend();
}

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.component("downloadExcel", JsonExcel);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
        libraries: 'places',
    },
    installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

Vue.directive('limit-future-date', {
    bind(el) {
      el.addEventListener('input', function(event) {
        const selectedDate = new Date(event.target.value);
        const currentDate = new Date();
  
        if (selectedDate > currentDate) {
          event.target.valueAsDate = currentDate;
          event.target.dispatchEvent(new Event('input'));
        }
      });
    },
});